export default __webpack_public_path__ + "static/media/unicrypt.40f49583.png";